import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import { TabComponent, TabsComponent } from '@recruitee/user-interface';

@Component({
  standalone: true,
  selector: 'rt-requisitions-tabs',
  templateUrl: './requisitions-tabs.component.html',
  imports: [RouterModule, TabComponent, TabsComponent, TranslatePipe],
})
export class RequisitionsTabsComponent {
  @Input() public offersCount: number = 0;
  @Input() public hiresCount: number = 0;
  @Input() public openingsCount: number = 0;
  @Input() public attachmentsCount: number = 0;
  @Input() public notesCount: number = 0;

  public get hiresTabCounter(): string {
    return `${this.hiresCount}/${this.openingsCount}`;
  }
}
